import { useEffect } from "react"

const Shop = () => {
    useEffect(() => {
        window.location.replace("https://abundanceextensions.com/")
    }, [])

    return null
}

export default Shop
